<template>
  <div class="wrapper">
    <table-page ref="childTable"  @btnclick="bthClick" :pageData="pageData"></table-page>
    <UPDATE  ref="childUpdate"  @submit="submit" :updateData="updateData"></UPDATE>
  </div>
</template>

<script>
    //table封装组件
    import tablePage from '@/components/page/table.vue'
    import UPDATE from '@/components/page/update.vue'
    //接口地址url的统一管理
    import URL from '@/views/newmis36/util/url'
    import Qs from 'qs'
    export default {
        name: 'list',
        components: {
            tablePage,
            UPDATE
        },
        mounted() {
          this.$refs.childTable.defaultQueryData();
        },
        methods: {
            /*表格按钮点击事件*/
            bthClick (clickName, row) {
                if (clickName == "update"){
                    this.$refs.childUpdate.open(row);
                }else if (clickName == "delete"){
                    this.dataChanage(URL.operation.delete,{id:row.id},res =>{
                        if (res.code == 0){
                            this.$message.success("suc");
                        }else{
                            this.$message.error(res.message);
                        }
                    });
                }
            },

            /*新增或跟提交数据触发事件*/
            submit(model){
                //根据是否包含id更新还是添加
                this.dataChanage(URL.operations.edit,model,res => {
                    if (res.code == 0){
                        this.$refs.childUpdate.close();
                        this.$message.success("suc");
                    }else{
                        this.$message.error(res.message);
                    }
                })
            },
            dataChanage(url,option,suc,fail){
                this.$axios.post(url, Qs.stringify(option || {})).then(res => {
                    this.$refs.childTable.defaultGetData();
                    if(suc && (typeof suc == 'function')) suc(res);
                }).catch(res => {
                    if(fail && (typeof fail == 'function')) fail(res);
                })
            }
        },
        data () {
            return {
                queryData:{},
                /*新增或更新*/
                updateData:{
                    cols:[
                      { title: "id", field: 'id',hidden: true},
                      { title: window.$t('txmis.operations.totalMem'), field: 'totalMem'},
                      { title: window.$t('txmis.operations.tradeTime'), field: 'tradeTime'},
                      { title: window.$t('txmis.operations.sud'), field: 'sud'},
                      { title: window.$t('txmis.operations.usd'), field: 'usd'},
                    ],
                },
                /*table生成*/
                pageData: {
                    isShow: false,
                    queryUrl: URL.operations.list, //请求路径和参数
                    isPage:false,
                    cols: [
                      { title: window.$t('txmis.operations.totalMem'), field: 'totalMem'},
                      { title: window.$t('txmis.operations.tradeTime'), field: 'tradeTime'},
                      { title: window.$t('txmis.operations.sud'), field: 'sud'},
                      { title: window.$t('txmis.operations.usd'), field: 'usd'},
                      {field:window.$t('txmis.bt.edit'),title:window.$t('txmis.bt.operation'),size:"mini",click:"update",type:"primary",icon:"el-icon-edit"},
                    ]
                }
            }
        }
    }
</script>
/**
* 总客户数（人）
*/
private String totalMem;

/**
* 交易次数（次）
*/
private String tradeTime;

/**
* 客户提款额（SUD）
*/
private String sud;

/**
* 送出赠金额（USD）
*/
private String usd;
